import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=f335ec3e&scoped=true"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"
import style0 from "./Welcome.vue?vue&type=style&index=0&id=f335ec3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f335ec3e",
  null
  
)

export default component.exports